/**
 * Registry for the active "unsaved changes" handler. React Router's getUserConfirmation
 * (in App) calls getUnsavedChangesPromptHandler(); useUnsavedChangesProtection
 * registers via setUnsavedChangesPromptHandler so the Unsaved changes modal is shown.
 */
type UnsavedChangesPromptHandler = (message: string, callback: (ok: boolean) => void) => void;

let currentHandler: UnsavedChangesPromptHandler | null = null;

export function setUnsavedChangesPromptHandler(handler: UnsavedChangesPromptHandler | null): void {
  currentHandler = handler;
}

export function getUnsavedChangesPromptHandler(): UnsavedChangesPromptHandler | null {
  return currentHandler;
}
